import React from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import InputField from "../../../components/form/InputField";
import { cities } from "../../../data/cities";
import { useTranslation } from "react-i18next";
import SubTitle from "../../../components/ui/SubTitle";

export interface Page1FormData {
  commercialRegister: string|null;
  taxNumber: string|null;
  city: string;
}

interface Props {
  register: UseFormRegister<Page1FormData>;
  errors: FieldErrors<Page1FormData>;
}

const StorePageOneForm: React.FC<Props> = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid sm:grid-cols-2 gap-4">
        <InputField
          placeholder="0000-0000-00"
          label={t('commercialRegister')}
          register={register("commercialRegister", {
            pattern: {
              value: /^\d{10}$/,
              message: t("invalid_commercialRegister"),
            },
          })}
          error={errors.commercialRegister}
        />

        <InputField
          placeholder="0000-0000-0000-000"
          label={t('taxNumber')}
          register={register("taxNumber", {
            pattern: {
              value: /^(\d{10}|\d{15})$/,
              message: t("invalid_tax_number_length"),
            },
          })}
          error={errors.taxNumber}
        />

      </div>

      <div className="mt-4">
        <SubTitle title={t('selectCity')} />
        <select
          {...register("city", { required: t("required_field") })}
          className="border border-LightGrey3  rounded p-3 mt-2 w-full  focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-sm"
        >
          <option value="">{t('selectCity')}</option>
          {cities.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
        {errors.city && <span className="text-red-500">{errors.city.message}</span>}
      </div>
    </>
  );
};

export default StorePageOneForm;
